const initialState = () => ({
    isMobile: null,
    isDesktop: null
  })
  
  const state = () => (initialState())
  
  const actions = {}
  
  const mutations = {
    SET_IS_MOBILE(state, { value }){
      state.isMobile = value
      state.isDesktop = !value
    },
  
    SET_IS_DESKTOP(state, { value }){
      state.isDesktop = value
      state.isMobile = !value
    }
  }
  
  const getters = {
    isMobile(state){
      return state.isMobile
    },
    isDesktop(state){
      return state.isDesktop
    }
  }
  
  export default {
    namespaced: true,
    state, actions, mutations, getters
  }
  


// WEBPACK FOOTER //
// ./src/stores/ui.js